(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('disease-type', {
            parent: 'entity',
            url: '/disease-type?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.diseaseType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/disease-type/disease-types.html',
                    controller: 'DiseaseTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('diseaseType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('disease-type-detail', {
            parent: 'entity',
            url: '/disease-type/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.diseaseType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/disease-type/disease-type-detail.html',
                    controller: 'DiseaseTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('diseaseType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'DiseaseType', function($stateParams, DiseaseType) {
                    return DiseaseType.get({id : $stateParams.id});
                }]
            }
        })
        .state('disease-type.new', {
            parent: 'disease-type',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/disease-type/disease-type-dialog.html',
                    controller: 'DiseaseTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                advantages: null,
                                offer: null,
                                documents: null,
                                sortOrder: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('disease-type', null, { reload: true });
                }, function() {
                    $state.go('disease-type');
                });
            }]
        })
        .state('disease-type.edit', {
            parent: 'disease-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/disease-type/disease-type-dialog.html',
                    controller: 'DiseaseTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DiseaseType', function(DiseaseType) {
                            return DiseaseType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('disease-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('disease-type.delete', {
            parent: 'disease-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/disease-type/disease-type-delete-dialog.html',
                    controller: 'DiseaseTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DiseaseType', function(DiseaseType) {
                            return DiseaseType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('disease-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
